import { render, staticRenderFns } from "./report-insights-qol.vue?vue&type=template&id=5129f6a6&scoped=true&"
import script from "./report-insights-qol.vue?vue&type=script&lang=js&"
export * from "./report-insights-qol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5129f6a6",
  null
  
)

export default component.exports